import * as React from 'react';

export const styles: { [key: string]: React.CSSProperties } = {
    alertRow: {
        marginBottom: 15
    },
    fieldHelp: {
        display: 'block',
        fontWeight: 'normal',
        fontSize: 12,
        color: '#777',
        marginTop: 2
    },
    statusCell: {
        marginTop: 4,
        fontSize: 12
    },
    statusValid: {
        color: '#3c763d'
    },
    statusInvalid: {
        color: '#a94442'
    },
    radioLabel: {
        marginRight: 15
    },
    radioInput: {
        marginRight: 5
    },
    footer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    initialsGroup: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 0,
        marginRight: 20
    },
    initialsLabel: {
        marginRight: 10,
        marginBottom: 0
    },
    initialsInput: {
        width: 50,
        marginRight: 10
    }
};
